import {SafetyMatchingTaskProps} from "./SafetyPlay";
import {useEffect, useState} from "react";
import arrayShuffle from "array-shuffle";
import {Pair} from "../../Shared/Model/GameData";


export default function SafetyMatching(props: SafetyMatchingTaskProps) {

    const [leftPositions,] = useState(
        arrayShuffle(props.pairs.map((answer, index) => Math.ceil(index * Math.random())))
    )

    const [rightPositions,] = useState(
        arrayShuffle(props.pairs.map((answer, index) => Math.ceil(index * Math.random())))
    )

    const rowClassName = (index: number, clicked: number, wrongClicked: number): string => {
        let classes = ["row"]
        if (props.completed.indexOf(index) !== -1) {
            classes.push("correct")
        } else if (clicked === index) {
            classes.push("selected")
        } else if (wrongClicked === index) {
            classes.push("wrong")
        }
        return classes.join(" ")
    }

    const colClassName = (pairs: Pair[], left: boolean): string => {
        let classes = ["column"]
        classes.push(left ? "left" : "right")
        if (pairs.length > 0 && !pairs[0].leftPart.text) {
            classes.push("empty")
        }
        return classes.join(" ")
    }

    const processClick = (pair: Pair, index: number, left: boolean) => {
        const result = left ? props.onLeftClicked(pair, index) : props.onRightClicked(pair, index)
        props.onClickResult(pair, index, result)
    }

    useEffect(() => {
        props.onLoaded()
    }, [])

    return <div className={"matching" + (props.solve ? " solved" : "")}>
        <div className={colClassName(props.pairs, true)}>
            {props.pairs.map((pair, index) =>
                <div key={"left-" + index} style={{order: props.solve ? index : leftPositions[index]}} className={rowClassName(index, props.leftClicked, props.leftWrongClicked)} onClick={() => processClick(pair, index, true)}>
                    <span>{pair.leftPart.text}</span>
                    { pair.leftPart.picture && <img src={pair.leftPart.picture} alt=""/> }
                </div>
            )}
        </div>
        <div className="column center"></div>
        <div className={colClassName(props.pairs, false)}>
            {props.pairs.map((pair, index) =>
                <div key={"right-" + index} style={{order: props.solve ? index : rightPositions[index]}} className={rowClassName(index, props.rightClicked, props.rightWrongClicked)} onClick={() => processClick(pair, index, false)}>
                    <span>{pair.rightPart}</span>
                </div>
            )}
        </div>
    </div>
}